export const css = {
	root: '-Q9xo1aX',
	heading: '_2Ky8xfvP',
	article: '_2JMSuUrP',
	' _key': 'ascm-theme/ascm/lcc-rcs/document'
};

export default css;
